<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
             md="8">
        <base-material-card color="indigo"
                            icon="mdi-content-copy"
                            title="Create template"
                            class="py-3 px-5">
          <v-form>
            <v-text-field color="secondary"
                          label="Name"
                          v-model="item.description" />
                          
            <v-switch v-model="item.isPrioritizedInSeach" label="Prioritized in seach" />
            <v-switch v-model="item.isAdvanced" label="Advanced" />
            <v-switch v-model="item.isSetAsDefault" label="Default" />
            
            <v-card-actions class="pa-0 mt-5">

              <v-spacer />

              <v-btn default
                     color="success"
                     @click="createItem">
                Create
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import router from '../../../router';
  import axios from "../../../utils/axios";

  import TrainingType from '../../../servcies/api/training/TrainingType'


  export default {

    name: 'TrainingTypeCreate',

    components: {
    },

    data: () => ({

      content: null,

      item: {
        id: -1,
        description: '',
      },
    }),

    created() {
      this.init();
    },
    methods: {

      createItem() {
        let loader = this.$loading.show();
        var data = this.item
        console.log(data)
        TrainingType.createType(data)
          .then((result) => {
            this.back();
            loader.hide();
          }).catch((err) => {
            console.log(err)
            loader.hide();
          });
      },

      back() {
        router.go(-1);
      },

      async init() {
      },
    }
  }
</script>

<style></style>
